import FragranceCard from '../collection/FragranceCard'

// §3.6 reveal-on-first-data tile row. `tiles` is already filtered upstream
// (buildTileTaxonomy) to only what has real data behind it — this component
// renders nothing at all if the list is empty, never an empty-state grid.
export default function TileTaxonomyRow({ tiles, compactGrid = false }) {
  if (!tiles.length) return null

  return (
    <section>
      <p className="mb-2 text-[10px] font-bold uppercase tracking-[0.14em] text-cream/35">Your fragrances</p>
      <div
        className={compactGrid ? 'grid grid-cols-3 gap-2' : '-mx-4 flex gap-3 overflow-x-auto px-4 pb-1'}
        data-visual-list="home-fragrance-tiles"
        data-layout={compactGrid ? 'compact-grid' : 'rail'}
      >
        {tiles.map(tile => (
          <div key={tile.key} className={compactGrid ? 'min-w-0' : ''} data-list-key={tile.key}>
            <FragranceCard
              frag={tile.fragrance}
              variant={compactGrid ? 'homeCompact' : 'home'}
              eyebrow={tile.label}
              primaryStat={tile.primaryStat}
              secondaryLine={tile.secondaryLine}
            />
          </div>
        ))}
      </div>
    </section>
  )
}
